import { DbName, DbVersion, StoreName } from "../@core/constants/db_name";
import { dbGetAllData, dbInsertAllData } from "./crudDB";

export async function dbTempCategoryListAllData(data) {
  await dbInsertAllData(
    DbName.TEMP_CATEGORY_LIST_DB,
    DbVersion.FIRST,
    StoreName.TEMP_CATEGORY_LIST,
    data
  );
}

export async function dbGetAllTempCategoryData() {
  return await dbGetAllData(
    DbName.TEMP_CATEGORY_LIST_DB,
    DbVersion.FIRST,
    StoreName.TEMP_CATEGORY_LIST,
    "id"
  );
}
